// src/components/restake/AssetsRestaked.tsx

import React from "react";
import { TAssetStat } from "./types";
import { Card, Typography } from "@kelp-dao/kernel-design-system";
import { useAssetRestaked } from "@hooks/useAssetRestaked";

const AssetsStats: React.FC<TAssetStat> = ({ value, coin, iconSrc }) => {
  return (
    <div className="text-left">
      <Typography
        type="body"
        variant="xsmall"
        className={"text-text-primary mb-1 text-[14x] md:text-[16px]"}
      >
        {value}
      </Typography>
      <div className="flex items-center justify-start gap-1">
        <img src={iconSrc} alt={coin} className="w-4 h-4" />
        <Typography
          type="misc"
          variant="overline"
          className="text-text-secondary whitespace-nowrap text-[10px] md:text-[12px]"
        >
          {coin}
        </Typography>
      </div>
    </div>
  );
};

const AssetsRestaked: React.FC = () => {
  const { assetsStakedStats } = useAssetRestaked();

  return (
    <Card
      variant="non-bordered"
      className={
        "bg-bg-secondary pb-6 pt-10 px-4 md:px-8 xl:p-8 md:pt-10 xl:pt-12 mb-8 rounded-b-2xl shadow-sm border-border-subtle -mt-4 relative z-[1]"
      }
    >
      <Typography
        type="body"
        variant="xsmall"
        className="text-[10px] md:text-[14px] text-text-secondary mb-3 font-semibold tracking-wider"
      >
        Assets restaked
      </Typography>
      <div className="flex justify-start items-center gap-4 md:gap-8">
        {assetsStakedStats?.map((asset, index) => (
          <div key={index} className="flex items-center">
            {index === assetsStakedStats.length - 1 && (
              <div className="w-[1px] h-10 bg-button-disabled-text mr-4 md:mr-8"></div>
            )}
            <AssetsStats
              key={index}
              value={asset.value}
              coin={asset.title}
              iconSrc={asset.icon}
            />
          </div>
        ))}
      </div>
    </Card>
  );
};

export default AssetsRestaked;
